import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import {
	setInitialLoginState,
	validateOtp,
	otplogin,
} from '../../../redux/userAuthentication/userAuth.actions';
import { setErrorPanel } from '../../../redux/utilities/utils.actions';
import FootNote from '../sharedComponents/footNote';
import '../userAuthenticationStyles.css';
import Config from '../../../config/Config';
import OtpField from '../sharedComponents/otpField';
import Loader from '../../../utils/Loader';

const delay = (duration) =>
	new Promise((resolve) => setTimeout(resolve, duration));

const ParentSignUp = ({
	loginId,
	setErrorPanel,
	validateOtp,
	userId,
	otp,
	error: { panelClass, panelMsg },
	resendOtp,
}) => {
	const [counter, setCounter] = useState(30);
	useEffect(() => {
		setErrorPanel({
			errorPanel: {
				panelClass: '',
				panelMsg: '',
			},
		});
		Loader.hide();
	}, [setErrorPanel]);

	useEffect(() => {
		if (counter < 31 && counter > 0) {
			(async () => {
				await delay(1000);
				setCounter((prev) => prev - 1);
			})();
		}
	}, [counter]);

	return (
		<div id="wrapper">
			<div className="col-lg-12 col-md-12 col-sm-12 login-pg-container">
				<div className="col-lg-12 col-md-12 col-sm-12 login-wrapper-container">
					<form action="" className="form-horizontal step-login-form" method="">
						<div className="col-lg-offset-4 col-md-offset-4 col-lg-4 col-md-4 col-sm-12 login-box">
							<div className="login-theader">
								<img src={Config.ASSETSPATH + 'img/STEP_logo.png'} alt="STEPlogo" />
							</div>
							<div className="message_box">
								<div className={panelClass}>{panelMsg}</div>
							</div>
							<p>
								We have sent an OTP to {loginId || localStorage.getItem('login_id')}.
								Please verify it to proceed.{' '}
							</p>
							<div className="login-formbox">
								<div className="form-group">
									<OtpField />
								</div>
							</div>
							<br />
							<Link to="/parent/login" className="pull-left">
								Change phone/email
							</Link>
							{!!counter && (
								<small className="mb-3">
									You can request another OTP if you do not receive it in {counter}{' '}
									seconds.
								</small>
							)}
							{counter === 0 && (
								<div
									className="pinResetBlock divAsAnchor mb-3"
									onClick={() => {
										setCounter(30);
										resendOtp(loginId);
									}}
								>
									Resend OTP
								</div>
							)}
							<button
								aria-label="login"
								id="loginBtn"
								type="button"
								className="btn-step-signin btn-primary"
								onClick={() => {
									validateOtp({
										otp,
										user_id: !!userId ? userId : localStorage.getItem('login_user_id'),
									});
								}}
							>
								Submit OTP
							</button>

							<hr />
							<FootNote userActivity="Verify OTP" />
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { loginId, success, userId, otp } = state.rootReducer.loginDetails;
	return {
		loginId,
		userId,
		otp,
		error: state.rootReducer.utils.errorPanel,
		success,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setErrorPanel: (errorText) => dispatch(setErrorPanel(errorText)),
		updateState: (value) => dispatch(setInitialLoginState(value)),
		validateOtp: (val) => dispatch(validateOtp(val)),
		resendOtp: (val) => dispatch(otplogin(val)),
	};
};
export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(ParentSignUp),
);
